<template>
  <LoadingScreen v-if="isSubmitting" />
  <SuccessScreen
    v-else-if="paymentAccount"
    :payment-account="paymentAccount"
    :confirm-text="$t('ppm_modal__financials_redirect_text')"
    @confirm="$emit('go-to-financials')"
    @close="$emit('close')"
  />
  <ErrorScreen
    v-else-if="error && error.showErrorScreen"
    :message="error.description"
    @go-to-financials="$emit('go-to-financials')"
    @close="$emit('close')"
  />
  <FormLayout
    v-else
    :heading="$t('ppm_modal__vc_heading')"
    :subheading="$t('ppm_modal__form_subheading')"
    :error="error"
  >
    <ValidationObserver v-slot="{ handleSubmit }" class="vc-col">
      <form class="vc-col" @submit.prevent="handleSubmit(onSubmit)">
        <div class="vc-col">
          <PersonalDetailsStep
            v-if="currentStep === 1"
            :values="formValues"
            @on-change="handleChange"
          />
          <BillingAddressStep
            v-if="currentStep === 2"
            :values="formValues"
            @on-change="handleChange"
          />
        </div>
        <FormFooter @on-back="handleGoBack()" />
      </form>
    </ValidationObserver>
  </FormLayout>
</template>

<script>
import { formatISO } from 'date-fns'
import LoadingScreen from '../LoadingScreen.vue'
import ErrorScreen from '../ErrorScreen.vue'
import FormFooter from '../../layouts/FormFooter.vue'
import FormLayout from '../../layouts/FormLayout.vue'
import BillingAddressStep from '../../forms/BillingAddressFormStep.vue'
import PersonalDetailsStep from '../../forms/PersonalDetailsFormStep.vue'
import StripePaymentMethodMixin from '../../mixins/StripePaymentMethodMixin'
import PreferredPaymentMethodMixin from '../../mixins/PreferredPaymentMethodMixin'
import SuccessScreen from './VirtualCardSuccessScreen.vue'

export default {
  components: {
    LoadingScreen,
    ErrorScreen,
    SuccessScreen,
    FormLayout,
    FormFooter,
    BillingAddressStep,
    PersonalDetailsStep,
  },
  mixins: [StripePaymentMethodMixin, PreferredPaymentMethodMixin],
  data() {
    return {
      currentStep: 1,
      paymentType: 'STRIPE_CARD_ISSUING_DIGITAL',
      formValues: {
        firstName: '',
        lastName: '',
        dob: null,
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
      },
      paymentAccount: null,
      error: null,
    }
  },
  computed: {
    issuingProduct() {
      return this.$store.getters['dashboard/issuingProduct']
    },
  },
  methods: {
    async createVirtualCard() {
      let entityPaymentVendorProductUuid = null
      if (this.issuingProduct) {
        entityPaymentVendorProductUuid = this.getProductUuid(
          this.issuingProduct
        )
      } else {
        const response = await this.createPaymentProduct({
          ...this.formValues,
          dob: formatISO(this.formValues.dob, { representation: 'date' }),
          option: this.paymentType,
        })
        if (response.error) {
          this.error = response.error
          return
        }

        entityPaymentVendorProductUuid = this.getProductUuid(
          response.data.product
        )
      }

      if (!entityPaymentVendorProductUuid) {
        return
      }

      // From PaymentsV4: Always create a card at this step. A user is not allowed
      // to edit a card, so no update is needed.
      const response = await this.createPaymentProductAccount({
        entityPaymentVendorProductUuid,
        createCardNow: false,
        cardType: 'virtual',
      })
      if (response.error) {
        this.error = response.error
        return
      }

      await this.persistPPM(
        response.data.account.entity_payment.entity_payment_uuid
      )
      this.paymentAccount = response.data.account
    },
    onSubmit() {
      if (this.currentStep === 2) {
        this.createVirtualCard()
        return
      }
      this.currentStep += 1
    },
    handleChange(newFormValues) {
      this.formValues = newFormValues
    },
  },
}
</script>

<style scoped>
.vc-col {
  @apply tw-flex tw-flex-col tw-flex-1;
}
</style>
